import Axios from "axios";
import { BaseService } from "./BaseService";
import { PaqueteContratado, PaqueteContratadoFiltro, PlanCaracteristica, PlanCaracteristicaFiltro, 
    PlanContradoAsignarProducto, PlanContradoProductoFiltro, PlanContratado, PlanContratadoEmpresaFiltro, 
    PlanContratadoFiltro, PlanPortadaFiltro, PlanRenovacionAutomatica, PlanRenovar } from "@/model/Plan";

BaseService.loadAxios();
const RESOURCE_NAME = "/Plan";

export class PlanService {
    public static async getPlanes(){
        return await Axios.get(RESOURCE_NAME);
    }

    public static async getPlanesPortada(filtro: PlanPortadaFiltro) {
        return await Axios.post(`${RESOURCE_NAME}/portada`, filtro);
    }

    public static async getPlanContratados(filtro: PlanContratadoFiltro) {
        return await Axios.post(`${RESOURCE_NAME}/contratados`, filtro);
    }

    public static async grabarPlanContratado(plan: PlanContratado) {
        return await Axios.post(`${RESOURCE_NAME}/grabar/contratado`, plan);
    }

    public static async getPlanCaracteristicas(filtro: PlanCaracteristicaFiltro) {
        return await Axios.post(`${RESOURCE_NAME}/caracteristicas`, filtro);
    }

    public static async grabarPlanCaracteristica(plan: PlanCaracteristica) {
        return await Axios.post(`${RESOURCE_NAME}/grabar/caracteristica`, plan);
    }

    public static async getPlanContratadoCaracteristicas(filtro: PlanCaracteristicaFiltro) {
        return await Axios.post(`${RESOURCE_NAME}/contratado/caracteristica`, filtro);
    }

    public static async grabarPlanContratadoCaracteristicas(plan: PlanContratado) {
        return await Axios.post(`${RESOURCE_NAME}/grabar/contratado/caracteristica`, plan);
    }
    
    public static async renovarPlanContratadoAsync(renovar: PlanRenovar) {
        return await Axios.post(`${RESOURCE_NAME}/renovar`, renovar);
    }
    
    public static async getPlanContratadosEmpresa(filtro: PlanContratadoEmpresaFiltro) {
        return await Axios.post(`${RESOURCE_NAME}/contratados/empresa`, filtro);
    }

    public static async cambiarRenovacionAutomaticaAsync(item: PlanRenovacionAutomatica) {
        return await Axios.put(`${RESOURCE_NAME}/cambiar/renovacion/automatica`, item);
    }

    public static async editarProductoPlanContratado(plan: PlanContradoAsignarProducto) {
        return await Axios.post(`${RESOURCE_NAME}/contratado/producto/editar`, plan);
    }

    public static async getProductosPlanContratado(filtro: PlanContradoProductoFiltro) {
        return await Axios.post(`${RESOURCE_NAME}/contratado/productos`, filtro);
    }
    
    public static async getPaquetesPlanContratado(filtro: PaqueteContratadoFiltro) {
        return await Axios.post(`${RESOURCE_NAME}/paquetes`, filtro);
    }

    public static async asginarPaquetePlanContratado(item: PaqueteContratado) {
        return await Axios.post(`${RESOURCE_NAME}/paquetes/grabar`, item);
    }


}